/*
 * @author Mateusz Mieszczak <mateusz.mieszczak at bossbyte.com>
 * @copyright BossByte Web Application
 */


app.directive('county', function ($http, $q, $timeout) {
	return {
		restrict: 'E',
		scope: {
			tState: '=',
			tModel: '='
		},
		templateUrl: "/assets/js/angular/components/directives/teryt/types/county.html",
		link: function (scope) {
			scope.counties = {
				list: [],
				item: null,
				text: null
			};

			scope.required = typeof scope.tModel.required == 'undefined'?false:scope.tModel.required;
			scope.disabled = typeof scope.tModel.disabled == 'undefined'?false:scope.tModel.disabled;

			$timeout(function () {
				if (!_.isNull(scope.tModel)) {
					scope.counties.text = scope.tModel.name;
				}
			}, 200);

			scope.countySearch = function (query) {
				var deferred = $q.defer();
				var post = {name: query};
				if (!_.isUndefined(scope.tState) && !_.isNull(scope.tState) && scope.tState!="") {
					post.state = scope.tState;
				}
				$http.post('/teryt/county', post)
					.success(function (list) {
						scope.counties.list = list;
						deferred.resolve(scope.counties.list.filter(scope.createFilterFor(query)));
					});

				return deferred.promise;
			};

			scope.createFilterFor = function (query) {
				return function filterFn(item) {
					return (angular.lowercase(item.name).indexOf(angular.lowercase(query)) === 0);
				};
			};
		}
	};
});
